import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { OrderLifetimeAction } from '@cbridge-packages/order-lifetime';

export const reloadOrderLifetimeListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    OrderLifetimeAction.create.done,
    OrderLifetimeAction.update.done,
    OrderLifetimeAction.remove.done,
  ),
  map(() => {
    return OrderLifetimeAction.loadList.started();
  }),
);
